export default [

	{
		name: 'Bob',
		avatar: 'AvatarVV_0173.png',
		algorithm: 'MediumBot',
		skill: 2,
		delay: 600, 
	},
	{
		name: 'Charlie',
		avatar: 'AvatarVV_0121.png',
		algorithm: 'LowestBot',
		skill: 1,
		delay: 600, 
	},
	{
		name: 'Dave',
		avatar: 'AvatarVV_0182.png',
		algorithm: 'LowestBot',
		skill: 1,
		delay: 600, 
	},
	{
		name: 'Eve',
		avatar: 'AvatarVV_0013.png',
		algorithm: 'LowestBot',
		skill: 1,
		delay: 600, 
	},
	{
		name: 'Sophie',
		avatar: 'AvatarVV_0183.png',
		algorithm: 'MediumBot',
		skill: 2,
		delay: 600, 
	},
	{
		name: 'Fred',
		avatar: 'AvatarVV_0006.png',
		algorithm: 'MediumBot',
		skill: 2,
		delay: 600, 
	},
	{
		name: 'Alice',
		avatar: 'AvatarVV_0014.png',
		algorithm: 'MediumBot',
		skill: 2,
		delay: 600,
	},
	{
		name: 'Grace',
		avatar: 'AvatarVV_0018.png',
		algorithm: 'HardBot',
		skill: 3,
		delay: 600,
	},
	{
		name: 'Hank',
		avatar: 'AvatarVV_0098.png',
		algorithm: 'HardBot',
		skill: 3,
		delay: 600,
	},
	{
		name: 'Iris',
		avatar: 'AvatarVV_0114.png',
		algorithm: 'HardBot',
		skill: 3,
		delay: 600,
	},
	{
		name: 'Nadia',
		avatar: 'AvatarVV_0043.png',
		algorithm: 'ExpectiminimaxBot',
		skill: 4,
		delay: 600,
	},

];